import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';

/*
  Generated class for the PreguntasProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PreguntasProvider {

  private api: string;
  constructor(public http: Http, public global: GlobalProvider) {
    this.api = this.global.api;
  }


  // Devuelve todos los poenentes de un congreso
  public all(clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavecongreso": clavecongreso
    };
    return this.http.post(this.api + "preguntas/lista.php", parametros, options).map(
      (response) => {
        
        return response.json();

      }
    ).catch(this.handleError);
  }

  // Devuelve el resultado de la pregunta interactiva
  public resultados(clavepreguntacab): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "clavepregunta": clavepreguntacab
    };
    
    return this.http.post(this.api + "preguntas/resultados.php", parametros, options).map(
      (response) => {
       
        return response.json();

      }
    ).catch(this.handleError);
  }

  // Devuelve todas las preguntas.
  /*public listapreguntas(clavepreguntacab): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "tabla": "preguntasdet",
      "campofiltro": "clavepreguntacab",
      "valorfiltro": clavepreguntacab
    };
   
    return this.http.post(this.api + "apigen/list.php", parametros, options).map(
      (response) => {
        
        return response.json();

      }
    ).catch(this.handleError);
  }*/
  public listapreguntas(clavepreguntacab,clavecongreso): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,      
       "clavecongreso": clavecongreso,
      "clavepreguntacab": clavepreguntacab
    };
   
    return this.http.post(this.api + "preguntas/listapreguntasadmin.php", parametros, options).map(
      (response) => {
        
        return response.json();

      }
    ).catch(this.handleError);
  }
   // Devuelve todas las preguntas.
   public listapreguntasdispositivo(clavepsesion,dispositivo): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,      
      "dispositivo": dispositivo,
      "clavepsesion": clavepsesion
    };
    
    return this.http.post(this.api + "congresos/preguntasresumendispositivo.php", parametros, options).map(
      (response) => {
        
        return response.json();

      }
    ).catch(this.handleError);
  }
  // Realiza una votación para una pregunta
  public votacion(dispositivo, parpregunta, parrespuesta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "identificador": this.global.token,
      "token": this.global.token,
      "dispositivo": dispositivo,
      "clavepregunta": parpregunta,
      "respuesta": parrespuesta
    };

    
    return this.http.post(this.api + "preguntas/votacion.php", parametros, options).map(
      (response) => {
       
        return response.json();

      }
    ).catch(this.handleError);
  }


  // Elimina una pregunta
  public delete(clavepregunta): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "preguntascab",
      "clave": clavepregunta,
    };

    return this.http.post(this.api + "apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

    // Elimina una pregunta
    public deletedet(clavepregunta): Observable<any> {
     
      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers });
  
      let parametros = {
        "token": this.global.token,
        "tabla": "preguntasdet",
        "clave": clavepregunta,
      };
  
      return this.http.post(this.api + "apigen/delete.php", parametros, options).map(
        (response) => {
          return response.json();
        }
      ).catch(this.handleError);
    }
  // Inserta una pregunta nueva
  public insert(congreso, pregunta): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    pregunta.clavecongreso = congreso.clave;
    
    let parametros = {
      "token": this.global.token,
      "tabla": "preguntascab",
      "parametros": pregunta
    };
   
    return this.http.post(this.api + "apigen/insert.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }
  public update(congreso, pregunta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "preguntascab",
      "clave": pregunta.clave,
      "parametros": pregunta
    };
   
    return this.http.post(this.api+"apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();
      
       return respuesta[0];
      }
    ).catch(this.handleError);
  }


  // Inserta una pregunta nueva
  public insertadet(congreso, sesion, pregunta): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    // pregunta.clavecongreso = congreso.clave;
    pregunta.clavepreguntacab =sesion;
    
    let parametros = {
      "clavecongreso":congreso.clave,
      "token": this.global.token,
      "tabla": "preguntasdet",
      "parametros": pregunta
    };
   
    return this.http.post(this.api + "apigen/insert.php", parametros, options).map(
      (response) => {
        
        return response.json();
      }
    ).catch(this.handleError);
  }
  public updatedet(congreso,  pregunta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "clavecongreso":congreso.clave,
      "token":this.global.token,
      "tabla": "preguntasdet",
      "clave": pregunta.clave,
      "parametros": pregunta
    };
    
    return this.http.post(this.api+"apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();
       
       return respuesta[0]; 
      }
    ).catch(this.handleError);
  }


  public preguntasprograma(claveprograma): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
       "claveprograma": claveprograma
    };
   
    return this.http.post(this.api+"programa/preguntasprograma.php", parametros, options).map(
      (response) => {
       
        return response.json();
        
      }
    ).catch(this.handleError);
  }


  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/providers/preguntas/preguntas.ts